"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEthersJsError = exports.parseTimestampRemaining = exports.parseSecondsRemaining = exports.EraswapInfo = exports.routine = void 0;
function routine(fn, msec) {
    var _this = this;
    var working = true;
    var result = fn();
    if (result instanceof Promise) {
        result.then(function () { return (working = false); });
    }
    else {
        working = false;
    }
    var intervalId = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!working) return [3 /*break*/, 2];
                    working = true;
                    return [4 /*yield*/, fn()];
                case 1:
                    _a.sent();
                    working = false;
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, msec);
    return intervalId;
}
exports.routine = routine;
exports.EraswapInfo = {
    baseUrl: 'https://eraswap.info',
    getAddressHref: function (address) {
        return this.baseUrl + "/address/" + address;
    },
    getTxHref: function (txHash) {
        return this.baseUrl + "/txn/" + txHash;
    },
};
function parseSecondsRemaining(numberOfSeconds) {
    var days = Math.floor(numberOfSeconds / 60 / 60 / 24);
    var hours = Math.floor((numberOfSeconds - days * 60 * 60 * 24) / 60 / 60);
    var minutes = Math.floor((numberOfSeconds - days * 60 * 60 * 24 - hours * 60 * 60) / 60);
    var seconds = numberOfSeconds - days * 60 * 60 * 24 - hours * 60 * 60 - minutes * 60;
    return "" + (days !== 0 ? days + " days, " : '') + (hours !== 0 ? hours + " hours, " : '') + (minutes !== 0 ? minutes + " minutes and " : '') + seconds + " seconds";
}
exports.parseSecondsRemaining = parseSecondsRemaining;
function parseTimestampRemaining(unixTimestampSeconds) {
    var currentTimestamp = Math.round(Date.now() / 1000);
    var secondsRemaining = currentTimestamp - unixTimestampSeconds;
    if (secondsRemaining < 0)
        secondsRemaining = 0;
    return parseSecondsRemaining(secondsRemaining);
}
exports.parseTimestampRemaining = parseTimestampRemaining;
var utils_1 = require("ethers/lib/utils");
function parseEthersJsError(error) {
    var _a, _b, _c;
    var isRevert = (((_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.code) || (error === null || error === void 0 ? void 0 : error.code)) === utils_1.Logger.errors.CALL_EXCEPTION;
    var reason = ((_b = error === null || error === void 0 ? void 0 : error.error) === null || _b === void 0 ? void 0 : _b.reason) || (error === null || error === void 0 ? void 0 : error.reason);
    var message = ((_c = error === null || error === void 0 ? void 0 : error.error) === null || _c === void 0 ? void 0 : _c.message) || (error === null || error === void 0 ? void 0 : error.message);
    return ((isRevert && reason && "Error from Smart Contract " + reason) ||
        (message && "Client-side error: " + message) ||
        "Unknown error: " + (typeof error === 'object' ? JSON.stringify(error) : error));
}
exports.parseEthersJsError = parseEthersJsError;
//# sourceMappingURL=utils.js.map